import { Box } from "@mui/material";
import Footer from "components/footer/Footer.component";
import { Outlet } from "react-router-dom";

// project imports
import Customization from "../Customization";

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
  <Box sx={{ position: 'relative' }}>
    <Outlet />
    <Customization />

    <Box sx={{ position: "absolute", bottom: 0, right: 0, left: 0, width: '100%' }}>
      <Footer />
    </Box>
  </Box>
);

export default MinimalLayout;
